import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';

import { getShortName } from '@utils/Util';

const SingleBlockImage = ({ item, setDesignIdToView, onViewFiles, blockListTab }) => {
	const onClickCollection = (e, item) => {
		e.stopPropagation();
		const url =
			blockListTab === 'BLOCKS_LIST'
				? `/collections/view/${item?.collectionId}?requestFrom=blockLibrary`
				: `/collections/view/${item?.collectionId}`;
		window.open(url, '_blank');
	};

	return (
		<div className="design-single-item mt-4">
			<div className="single-design-card with-editable ">
				<div className="card-top">
					<span>
						<img
							src={
								item?.featureImageList && item?.featureImageList.length > 0
									? item?.featureImageList[0]?.docUrl
									: `${process.env.PUBLIC_URL}/images/default_product.svg`
							}
							className="card-image"
							alt="product-image"
						/>
					</span>
					<div className="file-tags">
						{item?.hasPattern && <span>PT</span>}
						{item?.hasMeasurementChart && <span>MC</span>}
						{item?.has3D && <span>3D</span>}
						{item?.hasCad && <span>CAD</span>}
					</div>
					<div className="file-status">
						{item?.isBlock && (
							<div>
								<span className="status yellow-1 rounded">BLOCK</span>
							</div>
						)}
					</div>
					<div className="action-btns">
						<button
							className="button outline view-teckpack-button bg-white size32"
							onClick={() => setDesignIdToView(item?.id)}
						>
							Techpack
						</button>
						<button className="button view-load-button size32" onClick={onViewFiles}>
							Add to this Techapck
						</button>
					</div>
				</div>
				<div className="card-content">
					<div className="card-info">
						<div className="block-status d-flex gap-2 mb-2">
							{item?.isApprovedByBrand && (
								<span className="status green-1">
									Approved by: {item?.inspirationBrand?.name}
								</span>
							)}
						</div>
						<div className="">
							<h3 className="title-number semibold-12 mb-1">{item?.productRefNo}</h3>
							<h4 className="title-number semibold-12">{item?.blockTitle}</h4>
						</div>

						<div className="block-details-item-list">
							{(item?.productGroupResponse || item?.subCategoryResponse) && (
								<ul className="common-list-component mt-1">
									{item?.productGroupResponse && (
										<li className="text-uppercase">
											<Tooltip
												title={item?.productGroupResponse?.name}
												placement="top"
												arrow
											>
												<span className="regular-12 gray_dark_02">
													{getShortName(item?.productGroupResponse?.name, 17)}
												</span>
											</Tooltip>
										</li>
									)}
									{item?.subCategoryResponse && (
										<li className="text-uppercase">
											<Tooltip
												title={
													<span className="regular-14">
														{item?.subCategoryResponse?.name}
													</span>
												}
												placement="top"
												arrow
											>
												<span className="regular-12 gray_dark_02">
													{getShortName(item?.subCategoryResponse?.name, 10)}
												</span>
											</Tooltip>
										</li>
									)}
								</ul>
							)}

							{(item?.riseTag || item?.lengthTag) && (
								<ul className="common-list-component mt-1">
									{item?.riseTag && (
										<li className="text-uppercase">
											<Tooltip title={item?.riseTag?.text} placement="top" arrow>
												<span className="regular-12 gray_dark_02">
													{getShortName(item?.riseTag?.text, 17)}
												</span>
											</Tooltip>
										</li>
									)}
									{item?.lengthTag && (
										<li className="text-uppercase">
											<Tooltip title={item?.lengthTag?.text} placement="top" arrow>
												<span className="regular-12 gray_dark_02">
													{getShortName(item?.lengthTag?.text, 17)}
												</span>
											</Tooltip>
										</li>
									)}
								</ul>
							)}
							{(item?.inspirationBrand || item?.sizeStandardTag || item?.avatarTag) && (
								<ul className="common-list-component mt-1">
									{item?.inspirationBrand && (
										<li className="text-uppercase">
											<Tooltip
												title={item?.inspirationBrand?.name}
												placement="top"
												arrow
											>
												<span className="regular-12 gray_dark_02">
													{getShortName(item?.inspirationBrand?.name, 17)}
												</span>
											</Tooltip>
										</li>
									)}
									{item?.sizeStandardTag && (
										<li className="text-uppercase">
											<Tooltip
												title={item?.sizeStandardTag?.text}
												placement="top"
												arrow
											>
												<span className="regular-12 gray_dark_02">
													{getShortName(item?.sizeStandardTag?.text, 17)}
												</span>
											</Tooltip>
										</li>
									)}
									{item?.avatarTag && (
										<li className="text-uppercase">
											<Tooltip title={item?.avatarTag?.text} placement="top" arrow>
												<span className="regular-12 gray_dark_02">
													{getShortName(item?.avatarTag?.text, 17)}
												</span>
											</Tooltip>
										</li>
									)}
								</ul>
							)}
							{(item?.blockCreatedBy || item?.collectionName) && (
								<ul className="common-list-component mt-1">
									{item?.blockCreatedBy && (
										<li className="text-uppercase">
											<Tooltip title={item?.blockCreatedBy?.name} placement="top" arrow>
												<span className="regular-12 gray_dark_02">
													{item?.blockCreatedBy?.nickName
														? item?.blockCreatedBy?.nickName
														: getShortName(item?.blockCreatedBy?.name, 17)}
												</span>
											</Tooltip>
										</li>
									)}
									{item?.collectionName && (
										<li>
											<p
												className="collection-name regular-12 gray_dark_01 text-underline cursor-pointer pt-0"
												onClick={(e) => onClickCollection(e, item)}
											>
												{item?.collectionName}
											</p>
										</li>
									)}
								</ul>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SingleBlockImage;
